export default __webpack_public_path__ + "images/AI.b99e30f.png";